import { ApiResult, request, safeRequest } from '@synergy/api';

import {
    ExternalCustomerMappingFullResponse,
    ExternalCustomerMappingUpdateRequest,
} from '../../../../components/external-customer-mapping/external-customer-mapping';

export class CustomerExternalCustomerMappingApi {
    constructor(protected baseUrl: string) {}

    public getExternalCustomerMappings(customerId: number): Promise<ApiResult<ExternalCustomerMappingFullResponse[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers/${customerId}/external-customer-mappings`),
            response => response.data
        );
    }

    public updateExternalCustomerMappings(
        customerId: number,
        externalCustomerMappings: ExternalCustomerMappingUpdateRequest[]
    ): Promise<ApiResult<ExternalCustomerMappingFullResponse[]>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/customers/${customerId}/external-customer-mappings/update`, {
                    externalCustomerMappings,
                }),
            response => response.data
        );
    }

    public deleteExternalCustomerMappings(
        customerId: number,
        externalCustomerMappingId: number
    ): Promise<ApiResult<number>> {
        return safeRequest(
            () =>
                request.delete(
                    `${this.baseUrl}/customers/${customerId}/external-customer-mappings/${externalCustomerMappingId}`
                ),
            () => externalCustomerMappingId
        );
    }
}
